import React, { Component } from 'react';
import classNames from 'classnames';
import shallowEqual from 'shallowequal';
import RcCheckbox from '../rc-components/checkbox';
import CheckboxContext from './CheckboxContext';
export default class Checkbox extends Component {
    constructor() {
        super(...arguments);
        this.saveCheckbox = (node) => {
            this.rcCheckbox = node;
        };
    }
    static get contextType() {
        return CheckboxContext;
    }
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const { checkboxGroup, getPrefixCls } = this.context;
        return (!shallowEqual(this.props, nextProps) ||
            !shallowEqual(this.state, nextState) ||
            !shallowEqual(checkboxGroup, nextContext.checkboxGroup) || getPrefixCls !== nextContext.getPrefixCls);
    }
    focus() {
        this.rcCheckbox.focus();
    }
    blur() {
        this.rcCheckbox.blur();
    }
    render() {
        const { props, context } = this;
        const { prefixCls: customizePrefixCls, className, children, indeterminate, style, onMouseEnter, onMouseLeave, ...restProps } = props;
        const { checkboxGroup, getPrefixCls } = context;
        const prefixCls = getPrefixCls('checkbox', customizePrefixCls);
        const checkboxProps = { ...restProps };
        if (checkboxGroup) {
            checkboxProps.onChange = () => checkboxGroup.toggleOption({ label: children, value: props.value });
            checkboxProps.checked = checkboxGroup.value.indexOf(props.value) !== -1;
            checkboxProps.disabled = props.disabled || checkboxGroup.disabled;
        }
        const classString = classNames(className, {
            [`${prefixCls}-wrapper`]: true,
        });
        const checkboxClass = classNames({
            [`${prefixCls}-indeterminate`]: indeterminate,
        });
        return (React.createElement("label", { className: classString, style: style, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
            React.createElement(RcCheckbox, Object.assign({}, checkboxProps, { prefixCls: prefixCls, className: checkboxClass, ref: this.saveCheckbox })),
            children !== undefined ? React.createElement("span", null, children) : null));
    }
}
Checkbox.displayName = 'Checkbox';
Checkbox.defaultProps = {
    indeterminate: false,
};
